import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Member, MemberPersonTypes } from '../../models/domain/member';
import { MemberMergeRequest } from '../../models/ss-api/requests/member.merge.request';
import { Router } from '@angular/router';

export interface IMergeProfilesDialogModel {
    title: string;
    subTitle: string;
    message: string;
    MemberID: number;
}


@Component({
    selector: 'merge-profiles-dialog',
    styleUrls: ['./merge.profiles.dialog.css'],
    templateUrl: './merge.profiles.dialog.html'
})
export class MergeProfilesDialog extends DialogComponent<IMergeProfilesDialogModel, boolean> implements IMergeProfilesDialogModel, OnInit {

    IsBusy: boolean = false;
    OtherMemberIsBusy: boolean = false;
    MergeDisabled: boolean = false;

    chooseOtherProfile: boolean = true;

    title: string;
    subTitle: string;
    message: string;

    MemberID: number;
    MemberCurrent: Member = new Member();

    MergeID: number = 0;
    MemberOther: Member = new Member();

    MemberMerged: MemberMergeRequest = new MemberMergeRequest();

    MergeInvoices: boolean = true;
    MergeTrainingHistory: boolean = true;

    currentFirstName: boolean = true;
    currentLastName: boolean = true;
    currentCompany: boolean = true;
    currentEmail: boolean = true;
    currentPassword: boolean = true;
    currentPhone1: boolean = true;
    currentPhone2: boolean = true;
    currentFax: boolean = true;
    currentAddress1: boolean = true;
    currentCity: boolean = true;
    currentState: boolean = true;
    currentZipCode: boolean = true;
    currentCountry: boolean = true;
    currentSalesRep: boolean = true;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    async ngOnInit() {

        this.MemberCurrent = await this.getMember(this.MemberID);
        this.setMergedAsCurrent();

        this.MemberCurrent.Password = 'Current Profile Password';

    }

    async getOtherProfile() {
        this.MemberOther = await this.getMember(this.MergeID, true);

        if ((this.MemberOther.MemberType == MemberPersonTypes.ActiveMember || this.MemberOther.MemberType == MemberPersonTypes.CancelledMember) && (this.MemberCurrent.MemberType == MemberPersonTypes.ActiveDesigner || this.MemberCurrent.MemberType == MemberPersonTypes.CancelledDesigner || this.MemberCurrent.MemberType == MemberPersonTypes.OrphanedDesigner)) {
            this.MergeDisabled = true;
            this.sweetAlertService.swal({
                type: 'error',
                title: 'Error',
                text: 'Cannot merge a member into a designer',
                timer: 1500
            }).then(() => { }, () => { })
        } else {
            this.MergeDisabled = false;
            this.MemberOther.Password = 'Other Profile Password';

            this.chooseOtherProfile = false;
            this.setMergedAsCurrent();
            this.resetActiveOptions();
        }
    }

    async getMember(getThisID: number, gettingMergeMember: boolean = false): Promise<Member> {
        if (gettingMergeMember)
            this.OtherMemberIsBusy = true;
        else
            this.IsBusy = true;

        let newMember = new Member();

        await this.api.MemberFull(getThisID).toPromise().then(response => {
            newMember = response.Data;
        }, error => { });

        if (gettingMergeMember)
            this.OtherMemberIsBusy = false;
        else
            this.IsBusy = false;

        return newMember;
    }

    resetActiveOptions() {
        this.currentFirstName = true;
        this.currentLastName = true;
        this.currentCompany = true;
        this.currentEmail = true;
        this.currentPassword = true;
        this.currentPhone1 = true;
        this.currentPhone2 = true;
        this.currentFax = true;
        this.currentAddress1 = true;
        this.currentCity = true;
        this.currentState = true;
        this.currentZipCode = true;
        this.currentCountry = true;
    }

    setMergedAsCurrent() {
        this.MemberMerged.BaseMemberID = this.MemberID;
        this.MemberMerged.FirstName = this.MemberCurrent.FirstName;
        this.MemberMerged.LastName = this.MemberCurrent.LastName;
        this.MemberMerged.Email = this.MemberCurrent.Email;
        this.MemberMerged.CompanyName = this.MemberCurrent.CompanyName;
        this.MemberMerged.Phone1 = this.MemberCurrent.Phone1;
        this.MemberMerged.Phone2 = this.MemberCurrent.Phone2;
        this.MemberMerged.Address1 = this.MemberCurrent.Address1;
        this.MemberMerged.City = this.MemberCurrent.City;
        this.MemberMerged.State = this.MemberCurrent.State;
        this.MemberMerged.ZipCode = this.MemberCurrent.ZipCode;
        this.MemberMerged.Country = this.MemberCurrent.Country;
        this.MemberMerged.Fax = this.MemberCurrent.Fax;
        this.MemberMerged.PasswordMemberID = 'Current Profile Password';
    }

    onKey(event: any) {
        if (event.keyCode == 13)
            this.getOtherProfile();
    }

    MergeInvoiceClicked() {
        this.MergeInvoices = !this.MergeInvoices;
    }

    MergeTrainingHistoryClicked() {
        this.MergeTrainingHistory = !this.MergeTrainingHistory;
    }

    async confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code

        this.MemberMerged.BaseMemberID = this.MemberID;
        this.MemberMerged.MergeMemberID = this.MergeID;
        this.MemberMerged.MergeInvoices = this.MergeInvoices;
        this.MemberMerged.MergeTrainingHistory = this.MergeTrainingHistory;

        if (this.MemberMerged.PasswordMemberID == 'Current Profile Password')
            this.MemberMerged.PasswordMemberID = this.MemberID.toString();
        else
            this.MemberMerged.PasswordMemberID = this.MergeID.toString();

        await this.sweetAlertService.swal({
            title: 'Merge Members?',
            text: 'Are you sure you want to merge these member accounts?',
            type: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return this.api.MemberMerge(this.MemberMerged).toPromise();
            }
        }).then(async (response: any) => {
            if (response.Result){
                this.result = true;
                this.close();
                this.sweetAlertService.swal({
                    title: 'Success',
                    text: 'Members Merged',
                    type: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                })
                    .then((response: any) => {
                        this.result = true;
                        this.close();
                    }, (dismiss) => {
                        this.result = true;
                        this.close();
                        return;
                    }); // keep this line to prevent promise error;    
            }
            else{
                this.sweetAlertService.swal({
                    title: 'Error',
                    text: "An error occured performing the merge:  " + response.Data,
                    type: 'error',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                })
                    .then((response: any) => {
                        this.result = false;
                        this.close();
                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;                
            }
        }, (dismiss) => {
            return;
        }).catch(error => {
            this.sweetAlertService.swal({
                title: 'Error',
                text: error.message,
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'OK',
            })
                .then((response: any) => {
                    this.result = false;
                    this.close();
                }, (dismiss) => {
                    return;
                }); // keep this line to prevent promise error;
        });



    }


    updateItem(e: any) {
        let memberColumn: string = e.target.dataset.member;
        let clickedParameter = e.target.dataset.parameter;

        let setColumn: Member = (memberColumn.toLocaleLowerCase() == 'current' ? this.MemberCurrent : this.MemberOther);

        let newBool: boolean = (memberColumn.toLocaleLowerCase() == 'current' ? true : false);

        switch (clickedParameter.toLocaleLowerCase()) {
            case 'firstname':
                this.currentFirstName = newBool;
                this.MemberMerged.FirstName = setColumn.FirstName;
                break;
            case 'lastname':
                this.currentLastName = newBool;
                this.MemberMerged.LastName = setColumn.LastName;
                break;
            case 'email':
                this.currentEmail = newBool;
                this.MemberMerged.Email = setColumn.Email;
                break;
            case 'password':
                this.currentPassword = newBool;
                this.MemberMerged.PasswordMemberID = setColumn.Password;
                break;
            case 'company':
                this.currentCompany = newBool;
                this.MemberMerged.CompanyName = setColumn.CompanyName;
                break;
            case 'address1':
                this.currentAddress1 = newBool;
                this.MemberMerged.Address1 = setColumn.Address1;
                break;
            case 'city':
                this.currentCity = newBool;
                this.MemberMerged.City = setColumn.City;
                break;
            case 'state':
                this.currentState = newBool;
                this.MemberMerged.State = setColumn.State;
                break;
            case 'zip':
                this.currentZipCode = newBool;
                this.MemberMerged.ZipCode = setColumn.ZipCode;
                break;
            case 'country':
                this.currentCountry = newBool;
                this.MemberMerged.Country = setColumn.Country;
                break;
            case 'phone1':
                this.currentPhone1 = newBool;
                this.MemberMerged.Phone1 = setColumn.Phone1;
                break;
            case 'phone2':
                this.currentPhone2 = newBool;
                this.MemberMerged.Phone2 = setColumn.Phone2;
                break;
            case 'fax':
                this.currentFax = newBool;
                this.MemberMerged.Fax = setColumn.Fax;
                break;
            case 'salesrep':
                this.currentSalesRep = newBool;
                // this.MemberMerged.SalesRep = setColumn.SalesRep;
                break;
            default:
                break;
        }


    }

}
